import React from 'react';

const ConstructionLaborModeSelector = ({ currentMode, onModeChange, indicatorName, headerAction }) => {
  const modes = [
    { id: 'severity', label: 'Severity' },
    { id: 'total_present', label: 'Total Present Workers' },
    { id: 'forecast', label: 'Forecasted Severity' }
  ];

  return (
    <div className="power-outage-mode-selector construction-labor-mode-selector" style={{ position: 'relative' }}>
      <h4 className="viz-mode-title">{indicatorName} - Visualization Mode</h4>
      <div className="power-mode-tabs-row">
        <div className="power-mode-tabs" style={{ gridTemplateColumns: `repeat(${modes.length}, 1fr)` }}>
        {modes.map((mode) => (
          <div
            key={mode.id}
            className={`power-mode-tab ${currentMode === mode.id ? 'active' : ''}`}
            onClick={() => onModeChange(mode.id)}
            style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            {mode.label}
          </div>
        ))}
        </div>
        {headerAction}
      </div>
    </div>
  );
};

export default ConstructionLaborModeSelector;
